<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="115px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectId">
                 <!-- :disabled="model==='view'"  -->
              <el-select disabled
                v-model="form.projectId"
                style="width: 100%"
                placeholder="请选择项目名称"
                @change="projectIdChange"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"

                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          
          <el-col :span="12">
            <el-form-item label="服务点名称" prop="name">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.name"
                placeholder="请输入服务点名称"
                maxlength="20"
              ></el-input>  
            </el-form-item>
          </el-col>
        </el-row>
 <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="地点类型" prop="type">
              <el-select
                 :disabled="model==='view'" 
                v-model="form.type"
                style="width: 100%"
                placeholder="请选择地点类型"
                @change="communityTypeChange"
              >
                <el-option
                  v-for="item in communityTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>



          <el-col :span="12">
            <el-form-item label="所在地址" prop="address">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.address"
                placeholder="请输入所在地址"
                maxlength="50"
              ></el-input>  
            </el-form-item>
          </el-col>

        </el-row>
 <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="负责人" prop="contactName">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.contactName"
                placeholder="请输入负责人"
                maxlength="20"
              ></el-input>  
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.contactPhone"
                placeholder="请输入联系电话"
                maxlength="20"
              ></el-input>  
            </el-form-item>
          </el-col>


        </el-row>
 <el-row :gutter="24">

          <el-col :span="24">
            <el-form-item label="地点说明" prop="description">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.description"
                placeholder="请输入地点说明"
                type="textarea"
                maxlength="500"
                show-word-limit
              ></el-input>  
            </el-form-item>
          </el-col>

        </el-row>



      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import {
  saveProviderInfo,
  updateProviderInfo,
  saveProviderUserInfo,
  updateProviderUserInfo,
  getMatetial,
  getNursinghome,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  getNursingList,
  getDeviceTypeList,
  getDeviceModelList,
  saveWristband,
  getBasicInforDetail,
  updateWristband,
  getProviderList,
  saveCommunityInfo,
  updateServiceCommunity
} from '../api/serveItemManage';
import vUpload from "../components/mutil-upload.vue"
import md5 from 'js-md5';
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue'
    export default {
  components: {vUpload,choicePeople},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'singlePeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 1,
      },
      roleTypeList: [],
      provideList: [
      ],
      providerIdList: [],
      customerTypeList: [{
        name:'新用户',
        id:'1'
      },{
        name:'系统已有用户',
        id:'2'
      }],
      form: {
        projectId:'',
        nursinghomeId: '',
        downWarnValue: '',
        upWarnValue: '',
        releaseMode:"",
        authPictureUrlList:[],
        contactPictureUrlList:[],
        moduleTypesIds:[],
        moduleTypes:'',
        password_:'',
        password:'',
        id:'',
      },
      formRules: {
        type: [{ required: true, message: '服务地点类型不能为空', trigger: 'change' }],
        name: [{ required: true, message: '服务地点名称不能为空', trigger: 'blur' }],
        consumableName: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
        consumableCode: [{ required: true, message: '物料编码不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
      projectList:[],
      typeList:[],
      moduleTypeList:[],
      communityTypeList:[],
      sexList:[{
        dictKey:1,
        dictValue:'男'
      },{
        dictKey:'2',
        dictValue:'女'
      },{
        dictKey:'3',
        dictValue:'未知'
      }]
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    projectIdChange(id){
      this.choicePeopleOption.projectId = id;
    },
    customerTypeChange(id){
      this.form.id = '';
      this.choicePeopleOption.selectList = [];
    },
      handlePeople(){
          let idArry = this.form.customerServiceUserIds.split(',')
          let nameArry = this.form.customerServiceUserNames.split(',')
          let length = idArry.length
          for(let i =0;i<length;i++){
              let obj ={
                   id:idArry[i],
                    realName:nameArry[i],
              }
              this.choicePeopleOption.selectList.push(obj)
          }
      },
    //选人组件获取人员后赋值
    getPeople(obj){
        console.log("getPeople==========>",obj);
        let arr = [];
        obj.forEach((ele)=>{
            arr.push(ele.id);
        });
        this.form.userIdList = arr;
        this.form.customerServiceUserIds = arr.join(',');
        this.form.id = arr.join(',');
    //   this.ruleForm.userIds = obj.id
    },
    userIdChange(val){
      let self = this;
      this.userList.forEach(ele=>{
        if(ele.id === val){
          self.form.tel = ele.tel;
          self.form.idNumber = ele.idNumber;
        }
      })
    },
    consumableIdChange() {
      this.form.warehouseList = [];

      if (this.form.consumableId != '') {
        getWarehouseWarnSetting({
          nursinghomeId: this.form.nursinghomeId,
          type: '0',
          consumableId: this.form.consumableId,
        }).then((res) => {
          this.form = res.data;

          this.form.type = 0;
        });
      }
    },
    async initData() {
      
      console.log(this.form,this.model)
      getProjectList().then((res) => {
        this.projectList = res.data;
          this.form.projectId = res.data[0].id;
          this.form = this._.cloneDeep(this.form);
        getProviderList({projectId:this.row.projectId,status:1}).then((res) => {
          this.providerIdList = res.data;
        });
      });

      this.choicePeopleOption.projectId = this.form.projectId;
          console.log('getBasicInforDetail======================>');
      if(this.model === 'add'){
      }else{
        this.form = this._.cloneDeep(this.row);
        // this.form.moduleTypesIds = this.form.moduleTypes.split(',');
      }
      // getDictionary('nursinghome_device_category_type').then((res) => {
      //   this.deviceCategoryList = res.data;
      // });
      // getDictionary('nursinghome_payment_type').then((res) => {
      //   this.paymentTypeList = res.data;
      // });
      
      
      // getDictionary('out_order_service_provider_type').then((res) => {
      //   this.typeList = res.data;
      // });
      // getDictionary('out_order_module_type').then((res) => {
      //   this.moduleTypeList = res.data;
      // });
      getDictionary('out_order_service_provider_user_role_type').then((res) => {
        this.roleTypeList = res.data;
      });
      getDictionary('out_order_service_community_type').then((res) => {
        this.communityTypeList = res.data;
      });
      
      if (this.model === 'add') {
        // this.form.nursinghomeId = this.nursinghomeId;
        // await getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
        //   this.matetialList = res.data;

        //   if (this.matetialList.length > 0) {
        //     this.form.consumableId = this.matetialList[0].id;
        //   }
        // });
        //通过物料id获取仓库数据
        // if (this.form.consumableId != '') {
        //   this.consumableIdChange();
        // }
      } else {
      }
    },
    saveRecord() {
      if(this.form.moduleTypesIds&&this.form.moduleTypesIds.length>0){
        this.form.moduleTypes = this.form.moduleTypesIds.join(',');
      }
      // this.form.password = md5(this.form.password_)
      if ((this.model === 'add')) {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveCommunityInfo(this.form).then((res) => {
              this.$message.success('操作成功');
              this.$emit('success');
            });
          }
        });
      }else{
        
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            updateServiceCommunity(this.form).then((res) => {
              this.$message.success('编辑成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  